module.exports = __webpack_public_path__ + "img/noAnswer-verify.b4e7e4d3.png";